// This function is used to enable copy-pasting column values from Excel/Google sheets
// Each cell will get a new line - regardless if it's another column or row
export function replaceTabsWithLinebreaks(value: string) {
  return value.replace(/\t+/g, '\n');
}
